import { useIntl } from 'react-intl'

import { assetSvgPath } from 'interfaces/constants'

import {
  StyledWorkshopSelectCard,
  StyledWorkshopSelectCardTitle,
  StyledWorkshopSelectCardCategory,
  StyledWorkshopInfoRow,
  StyledWorkshopIcon,
  StyledWorkshopDateText,
  StyledWorkshopSelectCardInfo,
  StyledInfluencer,
  StyledInfluencerContainer,
  StyledInfluencerAvatar,
  StyledInfluencerName,
  StyledInfluencerWorkPlace,
  StyledWorkshopSelectBox,
  StyledWorkshopSelectCardContent,
} from './workshopSelectCard.styled'

type InfluencerInfoProps = {
  influencer: Influencer
}

const InfluencerInfo = ({ influencer }: InfluencerInfoProps) => {
  return (
    <StyledInfluencer>
      <StyledInfluencerAvatar src={influencer.avatar} />
      <StyledInfluencerName>{influencer.name}</StyledInfluencerName>
      <StyledInfluencerWorkPlace>
        {influencer.job_title}
      </StyledInfluencerWorkPlace>
    </StyledInfluencer>
  )
}

type WorkshopSelectCardProps = {
  workshop: Workshop
  isSelected: boolean
  onSelected: (workshop: Workshop) => void
}
export const WorkshopSelectCard = ({
  workshop,
  isSelected,
  onSelected,
}: WorkshopSelectCardProps) => {
  const { formatMessage: f } = useIntl()
  return (
    <StyledWorkshopSelectCard onClick={() => onSelected(workshop)}>
      <StyledWorkshopSelectCardContent>
        <StyledWorkshopSelectBox
          src={`${assetSvgPath}/checkbox-${
            isSelected ? 'check' : 'uncheck'
          }.svg`}
        />
        <StyledWorkshopSelectCardCategory>
          {workshop.type}
        </StyledWorkshopSelectCardCategory>
        <StyledWorkshopSelectCardTitle>
          {workshop.name}
        </StyledWorkshopSelectCardTitle>
        <StyledWorkshopSelectCardInfo>
          <StyledWorkshopInfoRow>
            <StyledWorkshopIcon src={`${assetSvgPath}/calendar.svg`} />
            <StyledWorkshopDateText>{workshop.time}</StyledWorkshopDateText>
          </StyledWorkshopInfoRow>
          <StyledWorkshopInfoRow>
            <StyledWorkshopIcon src={`${assetSvgPath}/location.svg`} />
            <StyledWorkshopDateText>{workshop.location}</StyledWorkshopDateText>
          </StyledWorkshopInfoRow>
          <StyledWorkshopInfoRow>
            <StyledWorkshopIcon src={`${assetSvgPath}/user.svg`} />
            <StyledWorkshopDateText>
              {f({
                id: 'spotlight.landing.workshop.influencer',
                defaultMessage: 'Influencer',
              })}
            </StyledWorkshopDateText>
          </StyledWorkshopInfoRow>
          <StyledInfluencerContainer>
            {workshop.influencers &&
              workshop.influencers.map((influencer, idx) => (
                <InfluencerInfo key={idx} influencer={influencer} />
              ))}
          </StyledInfluencerContainer>
        </StyledWorkshopSelectCardInfo>
      </StyledWorkshopSelectCardContent>
    </StyledWorkshopSelectCard>
  )
}
